import { StageNumberBadge } from './StageNumberBadge';
import type { ResolvedStageStepperStage } from './StageStepper';
import type { StageStepperDisplayMode, StageStepperStyles } from './stageStepperStyles';

export const StageStepperItem = ({
  resolvedStage,
  mode,
  onStageClick,
  styles,
  measurement = false,
}: {
  resolvedStage: ResolvedStageStepperStage;
  mode: StageStepperDisplayMode;
  onStageClick?: (stageId: string) => void;
  styles: StageStepperStyles;
  measurement?: boolean;
}) => {
  const { id, index, state, isActive, isLast, primaryLabel, secondaryLabel, renderAccessory } = resolvedStage;
  const showLabel = mode === 'full' || isActive;
  const clickable = !measurement && Boolean(onStageClick) && state !== 'locked';
  const accessory = renderAccessory?.(measurement);

  return (
    <div
      key={id}
      data-stage-id={measurement ? undefined : id}
      data-stage-state={measurement ? undefined : state}
      onClick={measurement ? undefined : () => onStageClick?.(id)}
      css={[styles.stageItemByState[state], clickable && styles.stageItemClickable]}
    >
      <StageNumberBadge state={state} index={index} styles={styles} measurement={measurement} />
      {showLabel
        ? (
          <span style={{ minWidth: 0 }}>
            <div css={styles.labelByState[state]}>{primaryLabel}</div>
            {mode === 'full' && secondaryLabel ? <div css={styles.secondaryLabel}>{secondaryLabel}</div> : null}
          </span>
        )
        : null}
      {showLabel && accessory ? <span data-stage-accessory='true'>{accessory}</span> : null}
      {!isLast
        ? (
          <span
            aria-hidden='true'
            css={[styles.connector, mode !== 'full' && styles.connectorCompactOverride]}
          />
        )
        : null}
    </div>
  );
};
